// Override Settings
var bcSfSearchSettings = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {};
